import { useContext } from 'react';
import AppContext from 'src/contexts/AppContext';

const useApp = () => {
  return useContext(AppContext);
};

export default useApp;
